import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    // 门店引流码列表
    storeDrainageCode: {
        url: `${customerApi}/api/oem_miniso/shop_contact_ways/{id}`,
        type: 'GET',
    },
    // 门店渠道
    storeChannels: {
        url: `${customerApi}/api/oem_miniso/shop_channels`,
        type: 'GET',
    },
    // 更新门店引流码
    updateStoreDrainageCode: {
        url: `${customerApi}/api/oem_miniso/shop_contact_ways/refresh`,
        type: 'POST',
    },
    updateGroupChatLink: {
        url: `${customerApi}/api/oem_miniso/group_chat_link/status`,
        type: 'PUT',
    },
}
